import { render, staticRenderFns } from "./automatedAssessmentInput.vue?vue&type=template&id=d415e3fe&scoped=true"
import script from "./automatedAssessmentInput.vue?vue&type=script&lang=js"
export * from "./automatedAssessmentInput.vue?vue&type=script&lang=js"
import style0 from "./automatedAssessmentInput.vue?vue&type=style&index=0&id=d415e3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d415e3fe",
  null
  
)

export default component.exports